<template>
  <div class="Space" id="drawingspace-space">
    <div class="Space__Drawing" id="drawingspace-drawing"><slot></slot></div>
  </div>
</template>

<script>
export default {
  name: "Space",
  data() {
    return {
      pages: 1
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
$blue: #31287c;

.Space {
  background: #1e1e1e;
  display: flex;
  height: 100%;
  width: 100%;
  overflow-y: scroll;
  @media print {
    padding: 0;
    height: auto;
    overflow: initial;
  }
  & > div {
    margin: auto;
  }
  &__Drawing {
    @media print {
      transform: none !important;
    }
  }
}
</style>
